import classNames from "classnames";
import { NavLink, useLocation } from "react-router";
import React from "react";
import { Nav } from "react-bootstrap";
import useWheelId from "@/hooks/useWheelId";
import Icon from "../Icon";
import {
    faUser as person,
    faChartPie,
    faClipboardCheck,
    faArrowTrendUp,
    faList,
    faCalendar,
    faBook
} from '@fortawesome/free-solid-svg-icons';


export default function Tabs() {
    const location = useLocation();
    const wheelId = useWheelId()
    return (<>

        <Nav variant="pills" >
            <Nav.Item>
                <Nav.Link as={NavLink} end to={`/${wheelId}`} active={location.pathname === `/${wheelId}`} eventKey={"ME"} className={classNames("d-flex justify-content-center align-items-center gap-1", { 'text-white': location.pathname === `/${wheelId}` })}>
                    <Icon icon={person} /> <span className="d-none d-sm-inline">Я</span>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link as={NavLink} to={`/${wheelId}/roles`} active={location.pathname === `/${wheelId}/roles`} eventKey={"PARTS"} className={classNames("d-flex justify-content-center align-items-center gap-1", { 'text-white': location.pathname === `/${wheelId}/roles` })}>
                    <Icon icon={faChartPie} /> <span className="d-none d-sm-inline">Баланс</span>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link as={NavLink} to={`/${wheelId}/plan`} active={location.pathname === `/${wheelId}/plan`} eventKey={"PLAN"} className={classNames("d-flex justify-content-center align-items-center gap-1", { 'text-white': location.pathname === `/${wheelId}/plan` })}>
                    <Icon icon={faClipboardCheck} /> <span className="d-none d-sm-inline">План</span>
                </Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
                <Nav.Link as={NavLink} to={`/${wheelId}/goals`} active={location.pathname === `/${wheelId}/goals`} eventKey={"GOALS"} className={classNames({ 'text-white': location.pathname === `/${wheelId}/goals` })}>
                    Цели
                </Nav.Link>
            </Nav.Item> */}

            <Nav.Item>
                <Nav.Link as={NavLink} to={`/${wheelId}/growth`} active={location.pathname === `/${wheelId}/growth`} eventKey={"GROWTH"} className={classNames("d-flex justify-content-center align-items-center gap-1", { 'text-white': location.pathname === `/${wheelId}/growth` })}>
                    <Icon icon={faArrowTrendUp} /> <span className="d-none d-sm-inline">Рост</span>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link as={NavLink} to={`/${wheelId}/lists`} active={location.pathname === `/${wheelId}/lists`} eventKey={"LISTS"} className={classNames("d-flex justify-content-center align-items-center gap-1", { 'text-white': location.pathname === `/${wheelId}/lists` })}>
                    <Icon icon={faList} /> <span className="d-none d-sm-inline">Списки</span>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link as={NavLink} to={`/${wheelId}/actions`} active={location.pathname === `/${wheelId}/actions`} eventKey={"ACTIONS"} className={classNames("d-flex justify-content-center align-items-center gap-1", { 'text-white': location.pathname === `/${wheelId}/actions` })}>
                    <Icon icon={faCalendar} /> <span className="d-none d-sm-inline">График</span>
                </Nav.Link>
            </Nav.Item>
            <Nav.Item>
                <Nav.Link as={NavLink} to={`/${wheelId}/reflection`} active={location.pathname === `/${wheelId}/reflection`} eventKey={"REFLECTION"} className={classNames("d-flex justify-content-center align-items-center gap-1", { 'text-white': location.pathname === `/${wheelId}/reflection` })}>
                    <Icon icon={faBook} /> <span className="d-none d-sm-inline">Рефлексия</span>
                </Nav.Link>
            </Nav.Item>
            {/*<Nav.Item>
                <Nav.Link as={NavLink} to={`/${wheelId}/summary`} active={location.pathname === `/${wheelId}/summary`} eventKey={"SUMMARY"} className={classNames({ 'text-white': location.pathname === `/${wheelId}/summary` })}>
                    Сводка
                </Nav.Link>
            </Nav.Item> */}
        </Nav>
    </>
    );
}